import { render, staticRenderFns } from "./IconTrendingAi.vue?vue&type=template&id=68291274"
import script from "./IconTrendingAi.vue?vue&type=script&lang=js"
export * from "./IconTrendingAi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports